import React, { useState, useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { prettyDateInterval } from '../components/common/dates'
import { getDateInterval } from '../components/common/dates'
import { Spacer } from '../components/common/Decorations';
import { ExportToPDF } from '../components/SaveAsPDF';
import '../styles/ExperiencePage.css';
import { useEffect } from 'react';


function transformExperienceData(backendData) {
  // Защита от null/undefined/не массива
  if (!Array.isArray(backendData) || backendData.length === 0) {
    return {
      current_page: "experience",
      stack_summary: [],
      experiences: []
    };
  }

  // 1. Собираем ВСЕ технологии из ВСЕХ опытов работы
  const allStackItems = [];
  backendData.forEach(exp => {
    if (Array.isArray(exp.stack)) {
      allStackItems.push(...exp.stack);
    }
  });

  // 2. Группируем по категориям (уникальные значения)
  const stackSummaryMap = {};
  allStackItems.forEach(item => {
    if (item && item.type && item.title) {
      if (!stackSummaryMap[item.type]) {
        stackSummaryMap[item.type] = new Set(); // Используем Set для уникальности
      }
      stackSummaryMap[item.type].add(item.title);
    }
  });

  // 3. Преобразуем Set в массив для итогового формата
  const stackSummary = Object.entries(stackSummaryMap).map(([category, itemsSet]) => ({
    category,
    items: Array.from(itemsSet) // Преобразуем Set в массив
  }));

  // 4. Формируем experiences (как было)
  const experiences = backendData.map(exp => ({
    company: exp.company || "Не указано",
    position: exp.position || "Не указано",
    employed_at: exp.employed_at || null,
    fired_at: exp.fired_at || null,
    stack: Array.isArray(exp.stack) ? exp.stack.map(item => item?.title || "") : [],
    responsibilities: typeof exp.responsibilities === 'string' 
      ? exp.responsibilities.split('\n').filter(line => line.trim()) 
      : [],
    achievements: typeof exp.achievements === 'string'
      ? exp.achievements.split('\n').filter(line => line.trim())
      : []
  }));

  return {
    current_page: "experience",
    stack_summary: stackSummary,
    experiences: experiences
  };
}


const ExperiencePage = () => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [experienceDataLoaded, setExperienceData] = useState(null);
    const pdfRef = useRef();
    const downloadRef = useRef(null);
    useEffect(() => {
      const onHashChange = () => {
        const id = window.location.hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      };
      window.addEventListener("hashchange", onHashChange);
      return () => window.removeEventListener("hashchange", onHashChange);
    }, []);

    useEffect(() => {
        // Загрузка данных с бэкенда
        fetch('/api/experience/list')
        .then(res => res.json())
        .then(data => {
            setExperienceData(data);
        })
        .catch(error => {
            console.error('Ошибка загрузки данных:', error);
            setExperienceData({
            current_page: "experience",
            stack_summary: [],
            experiences: []
            });
        });
    }, []);

    if (!experienceDataLoaded) {
        return <div>Загрузка...</div>;  // Лоадер, пока данные грузятся
    }

    console.log(experienceDataLoaded)

    const experienceData = transformExperienceData(experienceDataLoaded);
    console.log(experienceData)

    console.log("Loaded BiographyPage")
    // const [activeTab, setActiveTab] = useState('biography');
    
    var stackTitle = "МОЙ СТЕК"
    var experienceTitle = "МОЙ ОПЫТ"
    
    // const experienceData = {
    //     current_page: "experience",
    //     stack_summary: [
    //         { category: "language", items: ["JavaScript", "TypeScript", "Python"] },
    //         { category: "library", items: ["React", "Redux", "Node.js"] },
    //         { category: "devops", items: ["Docker", "AWS", "CI/CD"] },
    //         { category: "common", items: ["Git", "Agile", "JIRA"] }
    //     ],
    //     experiences: [
    //         {
    //             company: "TechCorp Inc.",
    //             position: "Senior Frontend Developer",
    //             employed_at: "2024-06-01",
    //             fired_at: null,
    //             stack: ["React", "TypeScript", "Redux", "Jest"],
    //             responsibilities: [
    //                 "Разработка и поддержка клиентской части веб-приложения",
    //                 "Оптимизация производительности React-приложения",
    //                 "Код-ревью и менторинг младших разработчиков"
    //             ],
    //             achievements: [
    //                 "Увеличил производительность приложения на 40%",
    //                 "Внедрил TypeScript, сократив количество багов на 25%"
    //             ]
    //         },
    //         {
    //             company: "WebSolutions Ltd.",
    //             position: "Frontend Developer",
    //             employed_at: "2022-01-01",
    //             fired_at: "2023-05-31",
    //             stack: ["JavaScript", "React", "Webpack"],
    //             responsibilities: [
    //                 "Разработка пользовательских интерфейсов",
    //                 "Интеграция с REST API",
    //                 "Написание unit-тестов"
    //             ],
    //             achievements: [
    //                 "Реализовал сложный интерактивный дашборд",
    //                 "Автоматизировал процесс сборки проекта"
    //             ]
    //         }
    //     ]
    // };
    
    
    return (
    <div>
        <Header currentPage={"experience"} />
        
        <div className='content'>
            <div className="title"><strong>{stackTitle}</strong></div>
            <div className="experienceStack">
                {experienceData.stack_summary.map((group) => (
                <div key={group.category} className="experienceStackChapter">
                    {group.items.map((item) => (
                    <div key={item} className="experienceStackItem">{item}</div>
                    ))}
                </div>
                ))}
            </div>

            <div className="title"><strong>{experienceTitle}</strong></div>

            {experienceData.experiences.map((experience, index) => (
            <React.Fragment key={experience.company}>
                <div className="experienceItem">
                    <br style={{ height: '5px' }} />
                    <span className="experienceTitle"><strong>{experience.company}</strong></span>
                    <span className="experiencePosition"><strong>{experience.position}</strong></span>
                    <p className="experiencePeriod">{prettyDateInterval(experience.employed_at, experience.fired_at)} ({getDateInterval(experience.employed_at, experience.fired_at)})</p>
                    <div className="experienceStackChapter">
                        {experience.stack.map((stack) => (
                        <div key={stack} className="experienceStackItem">{stack}</div>
                        ))}
                    </div>
                    <div className="experienceResponsibility">
                        <span className="experienceResponsibilityTitle"><strong>ОБЯЗАННОСТИ</strong></span>
                        {experience.responsibilities.map((row, i) => (
                        <p key={i} className="experienceResponsibilityItem">{row}</p>
                        ))}
                    </div>
                    { 
                      experience.achievements.length > 0 &&
                      <div className="experienceResponsibility">
                          <span className="experienceResponsibilityTitle"><strong>ДОСТИЖЕНИЯ</strong></span>
                          {experience.achievements.map((row, i) => (
                          <p key={i} className="experienceResponsibilityItem">{row}</p>
                          ))}
                      </div>
                    }
                    <br />
                </div>
                
                {/* Добавляем горизонтальную линию, если это не последний элемент */}
                {index < experienceData.experiences.length - 1 && <hr className="experienceDivider" />}
            </React.Fragment>
            ))}
            {/* <ExportToPDF /> */}
            <Spacer height={50}/>
            <div id="download" ref={downloadRef} style={{ textAlign: 'center' }}>
              <ExportToPDF  experienceData={experienceData} />
            </div>
            <Spacer height={50}/>

        </div>
        <Footer />
    </div>
    );
};

export default ExperiencePage;
